<template>
    <Container fluid>
        <div class="d-flex flex-wrap station-list-view" style="gap:14px;">
            <div
                v-for="station in stations"
                :key="station.id"
                cols="12"
            >
                <StationItem
                    :station="station"
                    :distance="getDistance(station.coordinates, station)"
                    :view="true"
                />
            </div>
        </div>
    </Container>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'

    import locationService from '@/services/location'

    import Container from '@/components/Vuetify/Container'
    import StationItem from '@/components/app/personal/station/StationItem'

    export default {
        name: 'StationAddressScreen',

        components: {
            Container,
            StationItem,
        },

        computed: {
            ...mapState('location', {
                locationState: state => state,
            }),

            ...mapGetters({
                stations: 'station/getStations',
            }),
        },

        mounted() {
            this.bootstrap()
        },

        methods: {
            async bootstrap() {
                await this.$store.dispatch('station/fetch')
                await this.$store.dispatch('location/fetch', this.$getLocation)
            },

            getDistance(coordinates = [], station) {
                const lat1 = this.locationState.location?.lat || 0
                const lng1 = this.locationState.location?.lng || 0

                const lat2 = coordinates[0] || 0
                const lng2 = coordinates[1] || 0

                return locationService.getDistanceFormatted(lat1, lng1, lat2, lng2)
            },
        },
    }
</script>
